import { useSelector } from "react-redux";

const useHotels = () => {
    const hotels = useSelector((state) => state.hotels);
    return hotels;
};

export default useHotels;